/** Spec 070: the state word beside an instrument in the pair picker. */
export interface FeedBadge {
  word: string
  /** Greyed: the instrument has no feed right now (still selectable). */
  muted: boolean
  reason: string | null
}

/** The state word shown beside an instrument name in the pair picker, from `GET /quant/feed` `state`. */
export function feedBadge(state: string | null | undefined): FeedBadge | null {
  switch (state) {
    case undefined:
    case null:
    case '':
      return null
    case 'live':
      return { word: 'Live', muted: false, reason: null }
    case 'connecting':
      return { word: 'Connecting', muted: false, reason: null }
    case 'closed':
      return { word: 'Market closed', muted: false, reason: null }
    default:
      return { word: 'No feed', muted: true, reason: `No live feed right now (${state.replace(/_/g, ' ')}). You can still open it; the chart waits for the feed.` }
  }
}
